import React from 'react';
import SMOAnalyticsChartCollectionItem from './SMOAnalyticsChartCollectionItem';
import SMOAnalyticsCollectionItem from './SMOAnalyticsCollectionItem';
import SMFormSpaceSelectBox from 'components/dashboard/form/SMFormSpaceSelectBox';
import SMConst from 'lib/SMConst';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import SMOwnerResource from 'resources/SMOwnerResource';

class SMOAnalyticsView extends React.Component {
  
  constructor(props) {
    super(props);
    this.isLoaded = false;
    this.state = {
      display: this.props.display,
      analytics: {},
      owner: this.props.owner.attributes,
      spaceId: this.props.spaceId,
      roomId: this.props.roomId,
      start: this.props.start,
      end: this.props.end,
    };
  }
  
  componentDidMount() {
    this.requestResource();
    const self = this;
    $(".js-datepicker").datepicker({
      dateFormat:"yymmdd",
      onClose:function(e){
        let state = Object.assign({}, self.state);
        state[this.name] = this.value;
        self.setState(state);
        self.requestResource();
      }}
    );
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.state.spaceId != prevState.spaceId ||
      this.state.roomId != prevState.roomId) {
      this.requestResource();
    }
  }
  
  requestResource(isAppend, callback){
    if (this.state.display == SMConst.Display.Loading) return;
    this.setState({display: SMConst.Display.Loading});
    let queries = {};
    if (this.state.spaceId) queries["space_id"] = this.state.spaceId;
    if (this.state.roomId) queries["room_id"] = this.state.roomId;
    if (this.state.start) queries["start"] = this.state.start;
    if (this.state.end) queries["end"] = this.state.end;
    let permanentUrl = Routes.owner_dashboard_analytics_path(this.state.owner.username, queries);
    SMHistoryHelper.replaceState(permanentUrl);
    
    $(this.refs.container).startLoading();
    SMOwnerResource.getAnalytics(this.state.owner.username, queries, (response, error)=>{
      $(this.refs.container).stopLoading();
      this.setState({display: SMConst.Display.Visible});
      if(error || !response) return;
      this.isLoaded = true;
      this.setState({
        analytics: response,
      });
    });
  }
  
  spaceSelectBoxDidChangeValue(value) {
    this.setState({spaceId: value, roomId: ""});
  }
  
  roomSelectBoxDidChangeValue(value) {
    this.setState({roomId: value});
  }
  
  formDidSubmit(e){
    this.currentPage = 1;
    this.requestResource();
    e.preventDefault();
  }
  
  render() {
    
    let items = [], chartItems = [];
    if (this.isLoaded) {
      let analytics = this.state.analytics;
      let data = [
        {
          title: "予約リクエスト数",
          prefix: analytics.total_request_count.prefix_text ,
          amount: analytics.total_request_count.amount_text,
          unit: analytics.total_request_count.suffix_text,
        },{
          title: "お問い合わせ数",
          prefix: analytics.total_inquiries_count.prefix_text ,
          amount: analytics.total_inquiries_count.amount_text,
          unit: analytics.total_inquiries_count.suffix_text,
        },{
          title: "成約数", 
          prefix: analytics.total_conversions_count.prefix_text ,
          amount: analytics.total_conversions_count.amount_text,
          unit: analytics.total_conversions_count.suffix_text,
        },{
          title: "成約金額", 
          prefix: analytics.total_sales.prefix_text ,
          amount: analytics.total_sales.amount_text,
          unit: analytics.total_sales.suffix_text,
        },{
          title: "支払い合計",
          prefix: analytics.total_payment.prefix_text ,
          amount: analytics.total_payment.amount_text,
          unit: analytics.total_payment.suffix_text,
        },{
          title: "稼働率",
          prefix: analytics.total_use.prefix_text ,
          amount: analytics.total_use.amount_text,
          unit: analytics.total_use.suffix_text,
        },{
          title: "レビュー数",
          prefix: analytics.total_reputations_count.prefix_text ,
          amount: analytics.total_reputations_count.amount_text,
          unit: analytics.total_reputations_count.suffix_text,
        },{
          title: "承認率",
          prefix: analytics.confirm_rate.prefix_text ,
          amount: analytics.confirm_rate.amount_text,
          unit: analytics.confirm_rate.suffix_text,
        },{
          title: "返答率", 
          prefix: analytics.reply_rate.prefix_text,
          amount: analytics.reply_rate.amount_text,
          unit: analytics.reply_rate.suffix_text,
        },{
          title: "平均返答時間", 
          prefix: analytics.reply_time_avg.prefix_text,
          //prefix: analytics.reply_time_avg.amount_text,
          amount: analytics.reply_time_avg.amount_text,
          unit: analytics.reply_time_avg.suffix_text,
        },{
          title: "成約率", 
          prefix: analytics.total_conversions_percent.prefix_text,
          amount: analytics.total_conversions_percent.amount_text,
          unit: analytics.total_conversions_percent.suffix_text,
        }
      ];
      for (let i = 0; i < data.length; i++) {
        let d = data[i];
        items.push(
          <SMOAnalyticsCollectionItem key={i}
            title={d["title"]}
            prefix={d["prefix"]}
            amount={d["amount"]} 
            unit={d["unit"]} />
        );
      }
        
      let chartData = [];
      // let chartData = [{
      //   title: "予約リクエスト数",
      //   prefix: "",
      //   amount: analytics.total_request_count.amount,
      //   unit: "",
      // },{
      //   title: "お問い合わせ数",
      //   prefix: "" ,
      //   amount: analytics.total_inquiries_count.amount,
      //   unit: "",
      // },{
      //   title: "成約数", 
      //   prefix: "",
      //   amount: analytics.total_conversions_count.amount,
      //   unit: "",
      // },{
      //   title: "売上", 
      //   prefix: "￥",
      //   amount: analytics.total_sales.amount,
      //   unit: "",
      // }];
      
      for (let i = 0; i < chartData.length; i++) {
        let d = chartData[i];
        chartItems.push(
          <SMOAnalyticsChartCollectionItem key={i}
            title={d["title"]}
            prefix={d["prefix"]}
            amount={d["amount"]} 
            unit={d["unit"]} />
        );
      }
    }
    else {
      for (let i = 0; i < 10; i++) {
        items.push(
          <SMOAnalyticsCollectionItem key={i}
            title="&nbsp;"
            prefix="&nbsp;"
            amount="&nbsp;"
            unit="&nbsp;" />
        );
      }
    }
    
    return (
      <div ref="container" className="dashboard-container clearfix mb30">
        <div className="dashboard-maincol">
          <div className="mb30">
            <h2 className="dashboard-title mb30">サマリー
              <div className="summary-selectarea">
                対象
                <span className="form-select__inner ml5 mr10">
                  <label className="form-select">  
                    <SMFormSpaceSelectBox 
                      ownerId={this.state.owner.username} 
                      spaceId={this.state.spaceId} 
                      options={{className:"w200"}}
                      delegate={this} />
                  </label>
                </span>
                期間
                <input name="start" type="text" className="js-datepicker form-text w110 ml5 mr5" value={this.state.start} placeholder="20160101" />
                〜
                <input name="end" type="text" className="js-datepicker form-text w110 mr10 ml5" value={this.state.end} placeholder="20160201" />
              </div>
            </h2>

            <h3 className="dashboard-title mb20">数値</h3>
            <div className="summary-total">
              {items}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
SMOAnalyticsView.defaultProps = {
  display: SMConst.Display.Visible,
  spaceId: "",
  roomId: "",
  start: "",
  end: "",
};
export default SMOAnalyticsView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/analytics/SMOAnalyticsView.jsx